import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  COLORS,
  DarkMode,
  Heading,
  Text,
} from '@podiumhq/design-system';
import { useTracking } from '@podiumhq/tracking';
import PodiumLogo from 'components/PodiumLogo';
import styled from '@emotion/styled';
import useChangePage from 'hooks/useChangePage';
import { MEDIUM_MEDIA_QUERY_WIDTH } from 'styles';
import { useTrialsContext } from 'contexts/TrialsContextProvider';
import EmailClientsModal from './components/EmailClients';
import { emailClients } from './emailDomains';

const ExistingUserInvitation = ({ invitationCode }) => {
  const { trackEvent } = useTracking();
  const changePage = useChangePage();
  const [showEmailModal, setShowEmailModal] = useState(false);

  useEffect(() => {
    trackEvent('trials.userInviteExists.viewed');
  });

  const handleSelectEmail = () => {
    const domain = checkForKnownEmailDomain();
    if (domain) {
      if (domain?.trackingEvent) trackEvent(domain.trackingEvent);
      return window.open(domain.url);
    }
    return setShowEmailModal(true);
  };

  const checkForKnownEmailDomain = () => {
    const domain = email.split('@').pop();
    return emailClients.find((knownDomains) =>
      knownDomains.domains.some((knownDomain) => knownDomain === domain)
    );
  };

  const { email, businessName } = useTrialsContext() || {};

  if (showEmailModal) return <EmailClientsModal />;
  return (
    <DarkMode>
      <Box backgroundColor="black.base" height="100vh">
        <Content>
          <PodiumLogo icon={true} invert={true} />
          <Heading
            color="silver.lightest"
            fontSize="2xl"
            fontWeight="semibold"
            padding="24px 0 16px 0"
          >
            Are you trying to join an existing Podium account?
          </Heading>
          <Section>
            <Text color={COLORS.silver.lightest} sx={{ lineHeight: '21px' }}>
              You’ve been invited to join {businessName}’s account. To join,
              <span style={{ fontWeight: '800' }}>
                {' '}
                check your email for the invitation link and sign in there.
              </span>
            </Text>
            <br />
            <Text color={COLORS.silver.lightest} sx={{ lineHeight: '21px' }}>
              If you want to start a free trial of Podium for your own business,
              we suggest using a different email.
            </Text>
          </Section>
          <Button
            variant="primary"
            id="trials-invite-found-check-email"
            onClick={handleSelectEmail}
            sx={{
              display: 'block',
              width: '100%',
              marginTop: '16px',
            }}
          >
            Yes, check my email
          </Button>
          <Button
            variant="outline"
            darkMode={true}
            id="trials-invite-found-continue-free-trial"
            onClick={() => changePage('/trials/creating-account')}
            color="silver.lightest"
            sx={{
              width: '100%',
              border: `1px solid ${COLORS.silver.lightest}!important`,
              marginTop: '16px',
            }}
          >
            No, I want to start a free trial
          </Button>
        </Content>
      </Box>
    </DarkMode>
  );
};

export default ExistingUserInvitation;

const Content = styled.div`
  width: 345px;
  margin-right: auto;
  margin-left: auto;
  padding-top: 22vh;
  height: 78vh;
  position: relative;

  @media (max-width: ${MEDIUM_MEDIA_QUERY_WIDTH}px) {
    padding-top: 4vh;
    height: 96vh;
  }
`;

export const Section = styled.section`
  padding-bottom: 16px;
`;
